const state = {
	menuKey:'',
	slidebarKey:'',
	navsList: Object
};
const mutations = {
	SetMenuKey: (state: any, value: string) => {
		state.menuKey = value;
	},
	SetSidebarKey:(state: any, value: string) => {
		state.slidebarKey = value;
	}
};

const actions = {
	
};
const getters = {

};
export default {
	state,
	actions,
	mutations,
	getters
};
